import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../../src/context/authFirebase';
import { collectionGroup, getDocs, where, query } from "firebase/firestore";
import { motion } from 'framer-motion';

export default function Careers() {
  const [careers, setCareers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const career = query(collectionGroup(db, "Post"), where("category", "==", "careers"));
      try {
        const querySnapshot = await getDocs(career);
        setCareers(querySnapshot.docs.map(doc => doc.data()));
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    document.title = "EIT Ghana Limited - Our Careers";
  }, []);

  return (
    <motion.div
      className="pt-16 bg-gray-50 min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >

      {/* ── BANNER CARD ── */}
      <section className="pt-8 pb-0">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">
          <motion.div
            className="bg-blueblack rounded-3xl p-10 lg:p-16 relative overflow-hidden"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.6 }}
          >
            <div className="absolute -top-16 -right-16 w-56 h-56 bg-yellowcolor/10 rounded-full" />
            <div className="absolute -bottom-10 right-32 w-36 h-36 bg-seablue/20 rounded-full" />
            <div className="relative z-10 max-w-xl">
              <p className="text-yellowcolor font-semibold text-xs uppercase tracking-widest mb-4">Join Us</p>
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">Careers</h1>
              <p className="text-gray-300 text-lg leading-relaxed">
                Join a team passionate about technology, entrepreneurship, and empowering Ghana's future.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── OPEN ROLES ── */}
      <section className="py-8 pb-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">

          <motion.div
            className="mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <p className="text-seablue font-semibold text-xs uppercase tracking-widest mb-2">Opportunities</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-blueblack">Open Roles</h2>
          </motion.div>

          {careers.length > 0 ? (
            <div className="grid md:grid-cols-2 gap-5">
              {careers.map((post, i) => (
                <motion.div
                  key={post.id || i}
                  className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 flex flex-col lg:flex-row"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.07, duration: 0.5 }}
                  viewport={{ once: true }}
                >
                  <img
                    className="w-full lg:w-44 h-44 object-cover flex-shrink-0 group-hover:scale-105 transition-transform duration-500"
                    src={post.file}
                    alt={post.title}
                  />
                  <div className="flex flex-col gap-3 p-6 justify-center">
                    <Link to={`/careers/${post.id}`}>
                      <h3 className="text-base font-bold text-blueblack hover:text-seablue transition-colors leading-snug">
                        {post.title}
                      </h3>
                    </Link>
                    <p className="text-gray-500 text-sm line-clamp-2 leading-relaxed">{post.body}</p>
                    <Link to={`/careers/${post.id}`}>
                      <button className="px-5 py-2 bg-blueblack text-white text-xs font-semibold rounded-full hover:bg-seablue transition-all duration-300 w-fit">
                        View Role
                      </button>
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-3xl p-14 shadow-sm text-center flex flex-col items-center gap-5">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center text-3xl">
                💼
              </div>
              <div>
                <h3 className="text-xl font-bold text-blueblack mb-3">No Current Openings</h3>
                <p className="text-gray-500 leading-relaxed max-w-md">
                  There are no job openings available right now. Email your resume to{' '}
                  <a href="mailto:info@eitghana.com" className="font-semibold text-seablue hover:underline">
                    info@eitghana.com
                  </a>{' '}
                  to be considered for future openings.
                </p>
              </div>
            </div>
          )}
        </div>
      </section>

    </motion.div>
  );
}
